import React from "react"
import styled from "styled-components"
import { Heading, Paragraph } from "components/_blueprint/Typography"
import LogoMojoSvg from "url:assets/images/Logo_Mojo.svg"
import KidsPng from "url:assets/images/illustrations/Kids.png"
import { desktop, mobile, tablet } from "components/_blueprint/Layout"
import { Advisor as AdvisorType, RiskReportData } from "hooks/useRiskReport"
import MojoLogoSvg from "url:assets/images/mojo-mini-logo-alt.svg"

export const Header = ({ riskReport }: { riskReport: RiskReportData }) => (
  <HeaderContainer>
    <HeadingCopyContainer>
      <MojoLogo src={LogoMojoSvg} />
      <Heading>Risk Reality Report</Heading>
      <Paragraph>
        <b>Protection is about love, not just loss</b>
      </Paragraph>
      <Paragraph weight={400}>
        If something did happen, are you confident you or your loved ones could pay the bills each
        month, including your mortgage? The reality is, it could happen to any one of us, at any
        time.
      </Paragraph>
      <Paragraph weight={600}>
        This is not a prediction of your future health and doesn't account for your full medical
        history or lifestyle.
      </Paragraph>
      {riskReport.advisor && <Advisor advisor={riskReport.advisor} />}
    </HeadingCopyContainer>
    <HeadingImgContainer>
      <KidsIllustration src={KidsPng} />
    </HeadingImgContainer>
  </HeaderContainer>
)

const Advisor = ({ advisor }: { advisor: AdvisorType }) => (
  <AdvisorSection>
    <AdvisorImg src={MojoLogoSvg} />
    <AdvisorText>
      <AdvisorName>{advisor.name}</AdvisorName>
      <AdvisorRole>{advisor.role}</AdvisorRole>
    </AdvisorText>
  </AdvisorSection>
)

const HeaderContainer = styled.div({
  maxWidth: 1200,
  margin: "0 auto",
  padding: "2rem",

  display: "flex",
  gap: "40px",
})

const HeadingCopyContainer = styled.div({
  flex: 2,

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
})

const HeadingImgContainer = styled.div({
  flex: 1,
  padding: "0 32px",

  [mobile]: {
    display: "none",
  },
  [tablet]: {
    display: "none",
  },
  [desktop]: {
    display: "block",
  },
})

const MojoLogo = styled.img({
  maxWidth: "128px",
  margin: "0 0 32px",
})

const KidsIllustration = styled.img({
  position: "relative",
  maxWidth: "390px",
})

const AdvisorSection = styled.div({
  display: "flex",
  gap: "16px",
})

const AdvisorImg = styled.img({
  width: 72,
  height: 72,
})

const AdvisorText = styled.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-evenly",
})

const AdvisorName = styled.p({
  margin: 0,
})

const AdvisorRole = styled.p({
  margin: 0,
  fontWeight: 600,
})
